import styled from "styled-components";

export const TabsWrapper = styled.div`
  button {
    padding: 25px 54px;
    border: none;
    background-color: transparent;
    font: 600 18px/25px "Roboto";
    color: #828282;
    cursor: pointer;
    &.active {
      border-radius: 5px;
      background-color: #f7f8f9;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
      color: #005aa3;
    }
  }
`;

export const ViewAdminWrapper = styled.div`
  border-radius: 5px;
  // background-color: #f7f8f9;
  // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
  // padding: 38px 32px;
 // margin-top: 34px;
  .filter-box{
    background: #fff;
    border-radius: 10px;
    padding: 30px;
  }
  .support-usr-typ {
    width: 235px;
  }
  .change-status-actions {
    .tooltip {
      position: absolute;
      display: none;
      right: 16px;
      top: -8px;
      padding-right: 8px;
      ul {
        position: relative;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
        border-radius: 5px;
        &:after {
          content: "";
          width: 8px;
          height: 8px;
          background-color: #fff;
          position: absolute;
          top: 12px;
          right: -4px;
          box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.1);
          transform: rotate(-45deg);
        }
        li {
          padding: 3px 10px;
          background-color: #fff;
          position: relative;
          z-index: 1;
          &:first-child {
            border-radius: 5px 5px 0 0;
          }
          &:last-child {
            border-radius: 0 0 5px 5px;
          }
          &:hover {
            background-color: #f0f3f4;
          }
        }
      }
    }
    &:hover {
      .tooltip {
        display: block;
      }
    }
  }
  .distributorautorlist
  {
    position: absolute;
    left: 66%;
    width: 300px;
    z-index: 99999;
    border: 1px solid;
    background: #fff;
    max-height: 285px;
    overflow: hidden;
    overflow-y: scroll;
    ul li {
      padding: 10px;
    }
  }
  .checkboxinputbox{
    margin-top: 13px;
  }

  .kyc-status-tooltip-wrapper {
    position: relative;
  }

  .kyc-status-tooltip-wrapper .tooltip {
    position: absolute;
    top: 20%;
    right: 100%;

    opacity: 0;
    visibility: hidden;

    background: #fff;
    border: 1px solid #e6e6e6;
    border-top-right-radius: 0px !important;
    padding: 5px;
    border-radius: 8px;
    min-width: 110px;
    z-index: 999;
  }

  .kyc-status-tooltip-wrapper:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .kyc-status-tooltip-wrapper .tooltip-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const AddAdminWrapper = styled.div`
  h2{
    border-right: 1px dotted #ccc;
    padding-right: 20px;
  }
  .box{
    display: flex;
    grid-gap: 110px;
    margin-top: 30px;
  }
  .left{
    flex: 1;
    border-right: 1px dotted #ccc;
    padding-right: 100px;
  }
  .right{
    flex: 1;
  }
  .role{
    width: 20%;
  }
  .email{
    width: 47%;
  }
`;
